import { connect } from "react-redux";
import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { addFileObject } from "app/helpers/commonInterface";
import {
  APPROVED,
  ASSIGNED,
  COMPLETED,
  ON_HOLD,
  //PAUSED,
  REJECTED,
  SENT_FOR_CHECK,
} from "app/helpers/constants";
import DropDown from "app/components/commonComponent/dropDown/DropDown";
import { getStatus, getStatusArr, showToastMessageFailure } from "app/helpers/helperFunction";
import { statusChangeData } from "../AdminTaskDetailPage";
import SentForCheckPopup from "./SentForCheckPopup";
import {
  getTask,
  taskAddForChecking,
  updateTaskStatus,
} from "app/reducers/task/taskAction";
import { useAuth } from "app/components/pages/auth";
import PausedStatusModal from "app/components/pages/task/component/PausedStatusModal";
import ImageDisplay from "app/components/commonComponent/ImageDisplay";
import { taskData } from "app/reducers/task/taskDataInterface";
import CompletedTaskPopup from "app/components/pages/task/component/CompletedTaskPopup";
import { KTSVG } from "_metronic/helpers";
import { EDIT_TASK } from "app/helpers/routes";
import { absolutePath } from "app/helpers/relativePath";
import PinSVG from "app/components/pages/task/component/PinSVG";

interface props {
  taskDetails: taskData;
  updateTaskStatusDispatch: Function;
  taskAddForCheckingDispatch: Function;
  getTaskData: Function;
}

export interface sentForCheckDataModal {
  id?: number;
  status?: number;
  reviewerId: string;
  reviewMessage: string;
  fileObject: addFileObject;
}

const TaskDetailHeader: FC<props> = ({
  taskAddForCheckingDispatch,
  updateTaskStatusDispatch,
  taskDetails,
  getTaskData
}) => {
  const params = useParams();
  const { currentUser } = useAuth();
  const [sentChekPopup, setSentCheckPopup] = useState({
    taskCheck: false,
    approve: false,
    rejected: false,
  });
  const [loading, setLoading] = useState(false);
  const [showPausedPopup, setShowPausedPopup] = useState({
    show: false,
    apiData: "",
  });
  const [showCompletedTaskPopup, setShowCompletedTaskPopup] = useState({
    show: false,
    apiData: "",
  });
  // const {timerState, timerClick} = useTrackingTimer();

  const statusChangeApiDispatch = async (
    e: any,
    startDate?: Date,
    referenceNumber?: string
  ) => {
    setLoading(true);
    await updateTaskStatusDispatch(
      {
        taskIds: [Number(params.id)],
        status: Number(e),
        startDate: startDate === undefined ? null : startDate,
        referenceNumber: referenceNumber === undefined ? null : referenceNumber,
      },
      Number(e?.target?.dataset?.id),
      () => {
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
    getTaskData(params.id);
  };
  // const onChangeStatusHandler = async (e: any) => {
  //   if (Number(e.target.dataset.id) === PAUSED.id) {
  //     setShowPausedPopup({ show: true, apiData: e });
  //   } else {
  //     statusChangeApiDispatch(e);
  //   }
  // };

  const onChangeStatusHandler = async (value: string, name: string) => {
    if (Number(value) === ON_HOLD.id) {
      setShowPausedPopup({ show: true, apiData: value});
    } else if (
      Number(value) === COMPLETED.id &&
      taskDetails.IsReferenceNoRequired &&
      taskDetails.Activities.every((activity) => activity.IsCompleted)
    ) {
      setShowCompletedTaskPopup({ show: true, apiData: value });
    } else if (Number(value) === COMPLETED.id && !taskDetails.Activities.every((activity) => activity.IsCompleted)) {
      showToastMessageFailure("All checklist need to be completed first")
    } else {
      statusChangeApiDispatch(value);
    }
  };

    const navigate = useNavigate();
  const editTaskHadler = () => {
      navigate(absolutePath(`${EDIT_TASK}/${taskDetails.Id}`));
    };

  return (
    <div className="card-header pt-5 border-0 align-items-start m-0">
      <div className="card-title flex-column">
        <div className="fw-bold d-flex gap-2">
          <div>Task Details</div>
          {taskDetails.IsOverdue && (
            <div className="d-flex align-items-center text-gray-500 fs-7">
              <PinSVG fill="#F1416C" />
              <div className="text-danger w-100px">Overdue</div>
            </div>
          )}
        </div>
      </div>

      <div className="d-flex flex-wrap gap-3 mb-3 align-items-start">
        <div className="d-flex  gap-3">
        <button
          className={`btn btn-icon btn-bg-light btn-sm btn-active-light-primary`}
          title="Edit"
          onClick={editTaskHadler}
        >
          <KTSVG
            path="/media/icons/duotune/art/art005.svg"
            className="svg-icon-3"
          />
        </button>
          {currentUser?.Id === taskDetails.AssigneeId && (
            <div className="">
              <button
                className="btn btn-sm btn-light btn-active-light-primary w-125px"
                onClick={() =>
                  setSentCheckPopup({ ...sentChekPopup, taskCheck: true })
                }
                disabled={taskDetails.StatusValue === APPROVED.id}
              >
                Send for Check
              </button>

              <SentForCheckPopup
                assigneeId={taskDetails.AssigneeId}
                taskDetails={taskDetails}
                closeModal={() =>
                  setSentCheckPopup({ ...sentChekPopup, taskCheck: false })
                }
                showPopup={sentChekPopup.taskCheck}
                sentTaskForCheckingDispatch={(
                  sentData: sentForCheckDataModal
                ) =>
                  taskAddForCheckingDispatch({
                    id: params.id,
                    status: SENT_FOR_CHECK.id,
                    ...sentData,
                  })
                }
              />
            </div>
          )}
          {currentUser?.Id !== taskDetails.AssigneeId && (
            <>
              <div className="">
                <button
                  className="btn btn-sm btn-light btn-active-light-success"
                  onClick={() =>
                    setSentCheckPopup({ ...sentChekPopup, approve: true })
                  }
                  disabled={taskDetails.StatusValue === APPROVED.id}
                >
                  Approve
                </button>

                <SentForCheckPopup
                  assigneeId={taskDetails.AssigneeId}
                  taskDetails={taskDetails}
                  closeModal={() =>
                    setSentCheckPopup({ ...sentChekPopup, approve: false })
                  }
                  showPopup={sentChekPopup.approve}
                  sentTaskForCheckingDispatch={(
                    sentData: sentForCheckDataModal
                  ) =>
                    taskAddForCheckingDispatch({
                      id: params.id,
                      status: APPROVED.id,
                      ...sentData,
                    })
                  }
                />
              </div>
              <div className="">
                <button
                  className="btn btn-sm btn-light btn-active-light-danger"
                  onClick={() =>
                    setSentCheckPopup({ ...sentChekPopup, rejected: true })
                  }
                >
                  Reject
                </button>

                <SentForCheckPopup
                  assigneeId={taskDetails.AssigneeId}
                  taskDetails={taskDetails}
                  closeModal={() =>
                    setSentCheckPopup({ ...sentChekPopup, rejected: false })
                  }
                  showPopup={sentChekPopup.rejected}
                  sentTaskForCheckingDispatch={(
                    sentData: sentForCheckDataModal
                  ) =>
                    taskAddForCheckingDispatch({
                      id: params.id,
                      status: REJECTED.id,
                      ...sentData,
                    })
                  }
                />
              </div>
            </>
          )}
        </div>

        <div>
          <DropDown
            placeholder="status"
            options={getStatusArr(taskDetails.StatusValue)}
            className={`form-select form-select-sm form-select-white show text-start w-175px status-border-${
              taskDetails.StatusValue
            } ${loading ? "display-dropdown-loader" : ""}`}
            apiCallDispatch={onChangeStatusHandler}
            displayLoader={loading}
            currentValue={{
              value: getStatus(taskDetails.StatusValue)?.id,
              name: getStatus(taskDetails.StatusValue)?.name,
            }}
            defaultValue={{
              value: getStatus(taskDetails.StatusValue)?.id,
              name: getStatus(taskDetails.StatusValue)?.name,
            }}
            showSorted={false}
          />
        </div>

        <PausedStatusModal
          setShowPausedPopup={setShowPausedPopup}
          showPausedPopup={showPausedPopup}
          updateFun={statusChangeApiDispatch}
        />
        <CompletedTaskPopup
          setShowCompletedTaskPopup={setShowCompletedTaskPopup}
          showCompletedTaskPopup={showCompletedTaskPopup}
          updateFun={statusChangeApiDispatch}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTaskData: (taskId: number) => dispatch(getTask(taskId)),
    updateTaskStatusDispatch: (
      data: statusChangeData,
      status: string,
      successCallback: Function,
      failureCallback: Function
    ) =>
      dispatch(
        updateTaskStatus({ data, status, successCallback, failureCallback })
      ),
    taskAddForCheckingDispatch: (sentData: sentForCheckDataModal) =>
      dispatch(taskAddForChecking(sentData)),
  };
};
export default connect(null, mapDispatchToProps)(TaskDetailHeader);
